import { IS_OPEN, SELECTED_ASSET, COMMENT_THREAD, TAB, HIDE_EMBEDDED_COMMENTS, APP_NAME, OBJECT_ID, OBJECT_TYPE, CTA_URL, MODULES_WITH_REPLIES, IS_EMBEDDED_COMMENTS_ENABLED, IS_COMMENT_MODE_ACTIVE, BROADCAST_COMMENT_MESSAGE, HIGHLIGHT_COMMENTABLE_AREA, SCROLL_TO_COMMENTABLE_AREA, COMMENTS_FILTER, CTA_COMMENT_ID, ASSETS_LAST_UPDATED, NOTIFICATION_SETTINGS_OPEN, UNREAD_REPLIES_MAP, HAS_UNRECOVERABLE_ERROR, ENABLED_FEATURES, IS_EMBEDDED_POPOVER_OPEN, EMBEDDED_POPOVER_PLACEMENT, EMBEDDED_COMMENT_COORDINATES, EMBEDDED_MODULE_ID, EMBEDDED_META_DESCRIPTION, IS_EMBEDDED_OPEN_FROM_COMMENT_MODE, COMMENTABLE_AREA_CLICK_COORDINATES, DELETE_COMMENT_REQUEST, EMBEDDED_POPOVER_ANCHOR_SELECTOR } from '../constants/CollaborationSidebarStateProperties';
import { COMMENT_FILTER_VALUES } from '../constants/commentFilterConstants';
import { TABS } from '../constants/tabs';
import { getCommentIdParam } from '../utils/urls';

/**
 * This record tracks all the sidebar state
 * that's of concern to the host app.
 */
/**
 * If adding a new piece of state:
 * make sure it's added and deployed in collaboration-sidebar-embeddable
 * before it's used by any app through the collaboration-sidebar lib.
 * Trying to set a non-existant property into an immutable record will cause a runtime error!!
 */
/**
 * If removing a piece of state:
 * First deprecate it's usage (without removing it from the state) and ensure that's deployed
 * across all apps. After it's not being used in any app or the embeddable, you can remove it from here.
 */
/**
 * Do not refactor the types of these state values as you
 * cannot keep them in sync between the library and embeddable.
 * Always migrate to a new state while maintaining
 * the existing state values before being able to deprecate them.
 */

function createCollaborationSidebarState(overrides) {
  return Object.assign({
    [IS_OPEN]: false,
    [TAB]: TABS.COMMENTS,
    [SELECTED_ASSET]: null,
    [COMMENT_THREAD]: null,
    [HIDE_EMBEDDED_COMMENTS]: false,
    [APP_NAME]: null,
    [OBJECT_ID]: null,
    [OBJECT_TYPE]: null,
    [CTA_URL]: null,
    [MODULES_WITH_REPLIES]: {},
    replyCounts: {},
    [IS_EMBEDDED_COMMENTS_ENABLED]: false,
    [IS_COMMENT_MODE_ACTIVE]: false,
    [BROADCAST_COMMENT_MESSAGE]: null,
    [COMMENTS_FILTER]: COMMENT_FILTER_VALUES.open,
    [CTA_COMMENT_ID]: getCommentIdParam(),
    [ASSETS_LAST_UPDATED]: {},
    [NOTIFICATION_SETTINGS_OPEN]: false,
    [UNREAD_REPLIES_MAP]: {},
    [HAS_UNRECOVERABLE_ERROR]: false,
    [ENABLED_FEATURES]: null,
    [IS_EMBEDDED_POPOVER_OPEN]: false,
    [EMBEDDED_POPOVER_PLACEMENT]: 'top',
    [EMBEDDED_COMMENT_COORDINATES]: {
      top: 0,
      left: 0,
      width: 0,
      height: 0
    },
    [EMBEDDED_MODULE_ID]: undefined,
    [EMBEDDED_META_DESCRIPTION]: undefined,
    [IS_EMBEDDED_OPEN_FROM_COMMENT_MODE]: false,
    [EMBEDDED_POPOVER_ANCHOR_SELECTOR]: undefined,
    [COMMENTABLE_AREA_CLICK_COORDINATES]: undefined,
    [DELETE_COMMENT_REQUEST]: {
      loading: false,
      error: false
    },
    // Deprecated
    [SCROLL_TO_COMMENTABLE_AREA]: null,
    [HIGHLIGHT_COMMENTABLE_AREA]: null
  }, overrides || {});
}
export default createCollaborationSidebarState;